import React, { useState, useEffect } from 'react';
import TableIcon from '../../assets/images/svg/TableMode.svg';
import GraphIcon from '../../assets/images/svg/GraphMode.svg';

const ScoringSwitch = ({className, onChange, value}) => {
  const mode = value || 1;

  const toggleMode = () => {
    onChange(mode === 1 ? 2 : 1);
  };

  return (
    <>
      <div className={`d-flex align-items-center gap-2 scoring-switch ${className}`} onClick={toggleMode} style={{ cursor: 'pointer' }}>
        <span className={`mode-name ${mode === 1 ? 'active' : ''}`}>
          Table Mode
        </span>

        <div className={`switch-wrapper ${mode == 1 ? 'table-mode' : 'graph-mode'}`}>
          <div className="switch-toggle">
            {mode === 1 ? <img src={`admin/${TableIcon}`} /> : <img src={`admin/${GraphIcon}`} />}
          </div>
        </div>

        <span className={`mode-name ${mode === 2 ? 'active' : ''}`}>
          Graph Mode
        </span>
      </div>
    </>
  );
};

export default ScoringSwitch;
